'use es6';

import Raven from 'Raven';
import AccountsAPI from './API';
import { List, Set as ImmutableSet } from 'immutable';
import RequestStatusTypes from 'hub-pickers-lib/constants/RequestStatusTypes';
import Account from './records/Account';
import { sortByField } from '../utils/sorts';
let accounts = null;
let pinnedAccounts = null;
let hubsFailedToLoad = false;
let accountsRequestStatus = RequestStatusTypes.UNINITIALIZED;

function getAccounts(includePins = false, includeStats = true) {
  if (!accounts) {
    accountsRequestStatus = RequestStatusTypes.PENDING;
    return AccountsAPI.getAccounts(includePins, includeStats).then(payload => {
      accountsRequestStatus = RequestStatusTypes.SUCCEEDED;
      accounts = List(payload.accounts.map(account => Account(account).set('products', ImmutableSet(account.products)))).sort(sortByField('accountName'));
      pinnedAccounts = List(payload.pinnedAccountIds);
      hubsFailedToLoad = payload.hubsFailedToLoad;

      if (accounts.size === 0) {
        Raven.captureMessage('Received empty list of accounts');
      }

      return {
        accounts,
        pinnedAccounts,
        accountsRequestStatus,
        hubsFailedToLoad,
        crossHublet: payload.crossHublet
      };
    }).catch(error => {
      Raven.captureException(error);
      accountsRequestStatus = RequestStatusTypes.FAILED;
      accounts = List();
      return {
        accounts,
        accountsRequestStatus
      };
    });
  }

  return Promise.resolve({
    accounts,
    accountsRequestStatus
  });
}

function getAccountsCrossHublet(includePins = false, includeStats = true) {
  if (!accounts) {
    accountsRequestStatus = RequestStatusTypes.PENDING;
    return AccountsAPI.getAccountsCrossHublet(includePins, includeStats).then(payload => {
      accountsRequestStatus = RequestStatusTypes.SUCCEEDED;
      accounts = List(payload.accounts.map(account => Account(account).set('products', ImmutableSet(account.products)))).sort(sortByField('accountName'));
      pinnedAccounts = List(payload.pinnedAccountIds);
      hubsFailedToLoad = payload.hubsFailedToLoad;

      if (accounts.size === 0) {
        Raven.captureMessage('Received empty list of accounts');
      }

      return {
        accounts,
        pinnedAccounts,
        accountsRequestStatus,
        hubsFailedToLoad,
        crossHublet: payload.crossHublet
      };
    }).catch(error => {
      Raven.captureException(error);
      accountsRequestStatus = RequestStatusTypes.FAILED;
      accounts = List();
      return {
        accounts,
        accountsRequestStatus
      };
    });
  }

  return Promise.resolve({
    accounts,
    accountsRequestStatus
  });
}

function getAccountsRequestStatus() {
  return accountsRequestStatus;
}

function setPinnedAccounts(updatedPinnedAccounts) {
  return AccountsAPI.setPinnedAccounts(updatedPinnedAccounts).then(payload => {
    pinnedAccounts = List(payload);
    return pinnedAccounts;
  });
}

export { getAccounts, getAccountsCrossHublet, getAccountsRequestStatus, setPinnedAccounts };